var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"component":"HomeCircles"}},[_c('div',{staticClass:"circle red"},[_vm._t("red")],2),_vm._v(" "),_c('div',{staticClass:"circle white"},[_vm._t("white")],2),_vm._v(" "),_c('div',{staticClass:"circle grey"},[_vm._t("grey")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }